import { AppRouteProps } from "@harea/component";
import React from "react";

const GroupCalendarOffDayCreateContainer = React.lazy(
    () => import("./container/GroupCalendarOffDayCreateContainer")
);

export const GroupCalendarOffDayCreateRoutes: Array<AppRouteProps> = [
    {
        path: "create",
        title: "std_custom_calendar",
        element: <GroupCalendarOffDayCreateContainer />,
    },
];
